import { reactive } from 'vue';

export default function useField(initialValue) {
  return reactive({
    error: null,
    validated: false,
    value: initialValue,
  });
}
